module.exports = __webpack_public_path__ + "img/loading.11c7c1dc.gif";